import { ReactElement } from 'react'
import { CloudSync, Download, Link } from '@mui/icons-material'
import { Box, CircularProgress } from '@mui/material'
import { TooltipIconButton } from '@ui/feedback'

interface Props {
  file: FileItem
  isGeneratingPreview: boolean
  isDownloading: boolean
  isUnlinking: boolean
  onGeneratePreview: () => void
  onDownload: () => void
  onUnlink: () => void
}

const Spinner = (): ReactElement => (
  <Box display="flex" alignItems="center" justifyContent="center" width={28}>
    <CircularProgress size={16} />
  </Box>
)

// Actions of the selected document ("Eigenschaften" header)
const DocumentActions = ({
  file,
  isGeneratingPreview,
  isDownloading,
  isUnlinking,
  onGeneratePreview,
  onDownload,
  onUnlink,
}: Props): ReactElement => {
  const isTemplate = file.template_key !== null
  // Markdown pages (optionally showing a file) always stay templates
  const canUnlink = isTemplate && file.template_key !== 'markdown-page'

  return (
    <>
      {isDownloading ? (
        <Spinner />
      ) : (
        <TooltipIconButton
          size="small"
          tooltip={isTemplate ? 'Vorschau erzeugen und herunterladen' : 'Herunterladen'}
          aria-label="Herunterladen"
          onClick={onDownload}
        >
          <Download fontSize="small" />
        </TooltipIconButton>
      )}
      {canUnlink &&
        (isUnlinking ? (
          <Spinner />
        ) : (
          <TooltipIconButton
            size="small"
            tooltip="Entkoppeln"
            aria-label="Entkoppeln"
            onClick={onUnlink}
          >
            <Link fontSize="small" />
          </TooltipIconButton>
        ))}
      {isTemplate &&
        (isGeneratingPreview ? (
          <Spinner />
        ) : (
          <TooltipIconButton
            size="small"
            tooltip="Vorschau erzeugen"
            aria-label="Vorschau erzeugen"
            onClick={onGeneratePreview}
          >
            <CloudSync fontSize="small" />
          </TooltipIconButton>
        ))}
    </>
  )
}

export default DocumentActions
